/*window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    fetch(window.Shopify.routes.root + 'cart.js')
      
.then(response => {
  console.log("Persisted event");
  return response.json();
}).then(json => {
  StyleMilb.AjaxCart.updateCartButton(json);
});
  } else {
    console.log("Non-persisted event");
  }
});*/

jQuery(document).ready(function ($){    
    $.noConflict();
     
  //Adding logic to open collection sidebar filter menus
    if($('#CollectionSidebar').length) {
      $("#CollectionSidebar-1").toggleClass("is-open");
      $("#SidebarDrawer-1").toggleClass("is-open");
      $("#CollectionSidebar .collapsible-trigger-btn[aria-controls='CollectionSidebar-1'] span.collapsible-trigger__icon").toggleClass("is-open-icon");
      $("#FilterDrawer .collapsible-trigger-btn[aria-controls='SidebarDrawer-1'] span.collapsible-trigger__icon").toggleClass("is-open-icon");
      $("#CollectionSidebar .collapsible-trigger-btn").on("click", function(){
            $(this).next('.collapsible-content').toggleClass("is-open");
        	console.log($(this).find('span.collapsible-trigger__icon'));
        	$(this).find('span.collapsible-trigger__icon').toggleClass("is-open-icon");
        });
    }   

  if (typeof(enrichCartDetails) === "function") {
    // Bespoke Shipping rates helper
    $DATA = enrichCartDetails($DATA,false,0);
  }

});